@if (showOverlay ) {
<div class="loading">Loading&#8230;</div>
}

<router-outlet></router-outlet>
<div id="dialogs"></div>